import { render } from "./PaymentMethodBox.vue?vue&type=template&id=5f72e95d&scoped=true"
import script from "./PaymentMethodBox.vue?vue&type=script&lang=js"
export * from "./PaymentMethodBox.vue?vue&type=script&lang=js"

import "./PaymentMethodBox.vue?vue&type=style&index=0&id=5f72e95d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f72e95d"]])

export default __exports__